module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.row.cert.status && false) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的运动员资质",
      "label": ""
    },
    on: {
      "click": function($event) {
        return _vm.$toast('正在建设中')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的教练员资质",
      "label": !_vm.row.cert.status ? '请先进行实名认证' : ''
    },
    on: {
      "click": _vm.toJiaolian
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的裁判员资质",
      "label": !_vm.row.cert.status ? '请先进行实名认证' : ''
    },
    on: {
      "click": _vm.toCaipan
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.row.cert.status) ? _c('div', {
    staticClass: "cert-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-yundongyuan.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.$toast('正在建设中')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-jiaolianyuan.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toJiaolian
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-caipanyuan.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toCaipan
    }
  })]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-empty', {
    attrs: {
      "description": "您还未实名认证，请认证后再查询"
    }
  }), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertIndex'
      }),
      expression: "{name: 'CertIndex'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("立即实名认证")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e363eeb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/experience/MyExperience.vue
// module id = 2298
// module chunks = 0